const digest = '7dd7bf85e310d495282c11deb9b6ae049468236cf09e8cc3d9c15c699eca111d';
const css = `._collapseCaret_10j4b_1>span:first-child{color:#fff!important;fill:#fff!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'collapseCaret': '_collapseCaret_10j4b_1' };
export const collapseCaret = '_collapseCaret_10j4b_1';
export { css, digest };